import { formatAmount } from '@/lib/utils/formatters'
import type { MrgReportRow } from '../types/api'
import { formatReportDate } from './reportDateDisplay'

export function padApplicantId(id: string | number | undefined): string {
  if (id == null) return '—'
  if (typeof id === 'string' && id.length > 6) return id
  return String(id).padStart(8, '0')
}

export function formatDateCell(value: string | undefined): string {
  return formatReportDate(value, '')
}

export function displayCell(value: string | number | undefined): string {
  if (value == null || value === '') return ''
  return String(value)
}

export function fullName(row: MrgReportRow): string {
  return [row.first_name, row.last_name].filter(Boolean).join(' ')
}

export function moneyCell(value: string | number | undefined): string {
  if (value == null || value === '') return ''
  return formatAmount(value)
}

export function isWeekSummaryRow(row: MrgReportRow): boolean {
  return row.Week === 'Week'
}
